import Instance from "./instance";

export const GetUserAnalytics = async () => {
    try {
        return await Instance.instanceToken.get(`/dashboard/userCount`);
    } catch (error) {
        return error;
    }
};
